import React, {Component} from 'react';
import {injectIntl} from 'react-intl';

import styles from './ThreadAssignReplyStatus.module.css';

class ThreadAssignReplyStatus extends Component {
    render() {
        return (
            <label title={this.props.intl.formatMessage({id: 'thread.assign_reply_status_tooltip'})} className={styles.label}>
                <input type="checkbox" checked={this.props.checked} onChange={this.props.onChange} style={{display: 'none'}}/>
                <svg width="18px" height="20px" viewBox="0 0 18 20" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <g transform="translate(-3.000000, -1.000000)"
                           fill={this.props.checked ? '#8CC14B' : '#D0021B'}
                        >
                            <g transform="translate(3.000000, 1.000000)">
                                <path d="M16,2 L11.82,2 C11.4,0.84 10.3,0 9,0 C7.7,0 6.6,0.84 6.18,2 L2,2 C0.9,2 0,2.9 0,4 L0,18 C0,19.1 0.9,20 2,20 L16,20 C17.1,20 18,19.1 18,18 L18,4 C18,2.9 17.1,2 16,2 L16,2 Z M9,2 C9.55,2 10,2.45 10,3 C10,3.55 9.55,4 9,4 C8.45,4 8,3.55 8,3 C8,2.45 8.45,2 9,2 L9,2 Z M9,6 C10.66,6 12,7.34 12,9 C12,10.66 10.66,12 9,12 C7.34,12 6,10.66 6,9 C6,7.34 7.34,6 9,6 L9,6 Z M15,18 L3,18 L3,16.6 C3,14.6 7,13.5 9,13.5 C11,13.5 15,14.6 15,16.6 L15,18 L15,18 Z"/>
                            </g>
                        </g>
                    </g>
                </svg>
            </label>
        );
    };
}

export default injectIntl(ThreadAssignReplyStatus);
